import { makeEnvironmentProviders } from '@angular/core';
import { IMAGE_LOADER, ImageLoader } from '@angular/common';
import { IMAGE_BASE } from '@/shared/tokens';
import { environment } from '@/../environments/environment';

export const provideImages = () =>
  makeEnvironmentProviders([
    {
      provide: IMAGE_LOADER,
      useValue: loader,
    },
    {
      provide: IMAGE_BASE,
      useValue: environment.strapi.image_url,
    },
  ]);

const loader: ImageLoader = (config) => {
  if (config.src.includes('a.storyblok.com')) {
    return config.src;
  }

  const url = new URL(environment.strapi.image_url);

  url.pathname = config.src;
  return url.toString();
};
